import { get, isEmpty } from 'lodash'
import { getConfiguration } from 'store/Configurations/selector'
import { getCurrentVenueId } from 'store/Venues/selector'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ConfigurationsForm from 'containers/ConfigurationsForm'
import { updateConfiguration } from 'store/Configurations/actions'
import { fetchConfigurations } from 'store/Configurations/actions'
import { fetchDevices } from 'store/Devices/actions'
import { fetchRevenues } from 'store/Revenues/actions'
import { fetchPrinters } from 'store/Printers/actions'
import Loader from 'components/Loader'

const ConfigurationsEdit = ({
  updateConfiguration,
  fetchConfigurations,
  editedItem,
  fetchDevices,
  fetchRevenues,
  fetchPrinters,
  venueId,
}) => {
  const [isDevicesLoading, setDevicesLoading] = useState(true)
  const [isPrintersLoading, setPrintersLoading] = useState(true)
  const [isRevenuesLoading, setRevenuesLoading] = useState(true)

  useEffect(
    () => {
      fetchDevices(venueId).then(() => setDevicesLoading(false))
      fetchPrinters(venueId).then(() => setPrintersLoading(false))
      fetchRevenues(venueId).then(() => setRevenuesLoading(false))
      fetchConfigurations(venueId)
    },
    // eslint-disable-next-line
    [venueId],
  )

  const isLoading =
    isDevicesLoading || isPrintersLoading || isRevenuesLoading || isEmpty(editedItem)

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <ConfigurationsForm callApi={updateConfiguration} title="Edit Configuration" />
      )}
    </>
  )
}

ConfigurationsEdit.propTypes = {
  updateConfiguration: PropTypes.func.isRequired,
  venueId: PropTypes.string.isRequired,
  editedItem: PropTypes.object,
  fetchDevices: PropTypes.func.isRequired,
  fetchRevenues: PropTypes.func.isRequired,
  fetchPrinters: PropTypes.func.isRequired,
  fetchConfigurations: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  editedItem: getConfiguration(state, get(ownProps, ['match', 'params', 'id'])),
  venueId: getCurrentVenueId(state),
})

const mapDispatchToProps = {
  updateConfiguration,
  fetchDevices,
  fetchRevenues,
  fetchPrinters,
  fetchConfigurations,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ConfigurationsEdit)
